/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  // scroll top fixed header
  $(document).ready(function () {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('.nav-secondary').fadeIn();
        $('.nav-secondary').addClass("fixed-top");
      }
      else {
        $('.nav-secondary').removeClass("fixed-top");
      }
    });
    $('.nav-secondary').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 100);
      return false;
    });
    $(".hamburger").click(function () {
      $(".secondary-nav").toggleClass("openmenu");
      $("body").toggleClass("menuopen");
    });
  });



  $(document).ready(function(){
    var session = sessionStorage.getItem('ThemeContrast');
    //alert(session);
    // Append the stylesheet on page load
    if (session === 'yellowThemeContrast') {
         $('body').addClass('yellow-theme');   
      $('body').removeClass('black-theme'); 
      $('body').removeClass('yellow-text-theme'); 
  
      $(this).addClass('active');   
      $('#blackTheme').removeClass('active'); 
      $('#yellowTextTheme').removeClass('active'); 
    }else if(session === 'blackTheme'){
        $('body').addClass('black-theme');   
      $('body').removeClass('yellow-theme'); 
      $('body').removeClass('yellow-text-theme'); 
  
      $(this).addClass('active'); 
      $('#yellowTheme').removeClass('active');
      $('#yellowTextTheme').removeClass('active');
    }  else if(session === 'yellowTextTheme'){
        $('body').addClass('yellow-text-theme');
      $('body').removeClass('black-theme');   
      $('body').removeClass('yellow-theme');
  
      $(this).addClass('active'); 
      $('#yellowTheme').removeClass('active');
      $('#blackTheme').removeClass('active'); 
    }  
    else{
         $('body').removeClass('yellow-theme');    
      $('body').removeClass('black-theme'); 
      $('body').removeClass('yellow-text-theme'); 
      
      $('#yellowTheme').removeClass('active');
      $('#blackTheme').removeClass('active'); 
      $('#yellowTextTheme').removeClass('active'); 
    }    
  });
  
  
  $(document).ready(function(){
    var session = sessionStorage.getItem('ThemeContrast');
    // Append the stylesheet on page load
    if (session === 'yellowThemeContrast') {
         $('body').addClass('yellow-theme');   
      $('body').removeClass('black-theme'); 
      $('body').removeClass('yellow-text-theme'); 
  
      $(this).addClass('active');   
      $('#blackTheme').removeClass('active'); 
      $('#yellowTextTheme').removeClass('active'); 
    }else if(session === 'blackTheme'){
        $('body').addClass('black-theme');   
      $('body').removeClass('yellow-theme'); 
      $('body').removeClass('yellow-text-theme'); 
  
      $(this).addClass('active'); 
      $('#yellowTheme').removeClass('active');
      $('#yellowTextTheme').removeClass('active');
    }  else if(session === 'yellowTextTheme'){
        $('body').addClass('yellow-text-theme');
      $('body').removeClass('black-theme');   
      $('body').removeClass('yellow-theme');
  
      $(this).addClass('active'); 
      $('#yellowTheme').removeClass('active');
      $('#blackTheme').removeClass('active'); 
    }  
    else{
         $('body').removeClass('yellow-theme');    
      $('body').removeClass('black-theme'); 
      $('body').removeClass('yellow-text-theme'); 
      
      $('#yellowTheme').removeClass('active');
      $('#blackTheme').removeClass('active'); 
      $('#yellowTextTheme').removeClass('active'); 
    }    
  });
  
  
  
  $(document).ready(function () {  
                   
    $('#blackTheme').click(function() {  
        sessionStorage.setItem('ThemeContrast','blackTheme');
      $('body').addClass('black-theme');   
      $('body').removeClass('yellow-theme'); 
      $('body').removeClass('yellow-text-theme'); 
  
      $(this).addClass('active'); 
      $('#yellowTheme').removeClass('active');
      $('#yellowTextTheme').removeClass('active');
    });
  
   $('#yellowTextTheme').click(function() { 
       sessionStorage.setItem('ThemeContrast','yellowTextTheme');
       
    $('body').addClass('yellow-text-theme');
      $('body').removeClass('black-theme');   
      $('body').removeClass('yellow-theme');
  
      $(this).addClass('active'); 
      $('#yellowTheme').removeClass('active');
      $('#blackTheme').removeClass('active'); 
    });
    
    $('#yellowTheme').click(function() {  
        sessionStorage.setItem('ThemeContrast','yellowThemeContrast');
        
      $('body').addClass('yellow-theme');   
      $('body').removeClass('black-theme'); 
      $('body').removeClass('yellow-text-theme'); 
  
      $(this).addClass('active');   
      $('#blackTheme').removeClass('active'); 
      $('#yellowTextTheme').removeClass('active');    
    });
  
    $('#resetTheme').click(function() { 
        sessionStorage.setItem('ThemeContrast','reset');
      $('body').removeClass('yellow-theme');    
      $('body').removeClass('black-theme'); 
      $('body').removeClass('yellow-text-theme'); 
      
      $('#yellowTheme').removeClass('active');
      $('#blackTheme').removeClass('active'); 
      $('#yellowTextTheme').removeClass('active');           
    });
  });
  







  /*
   * jQuery jFontSize Plugin
   * Examples and documentation: http://jfontsize.com
   * Author: Frederico Soares Vanelli
   *         fredsvanelli@gmail.com
   *         http://twitter.com/fredvanelli
   *         http://facebook.com/fred.vanelli
   *
   * Copyright (c) 2011
   * Version: 1.0 (2011-07-15)
   * Dual licensed under the MIT and GPL licenses.
   * http://jfontsize.com/license
   * Requires: jQuery v1.2.6 or later
   */

  (function ($) {
    $.fn.jfontsize = function (opcoes) {
      var $this = $(this);
      var defaults = {
        btnMinusClasseId: '#jfontsize-minus',
        btnDefaultClasseId: '#jfontsize-default',
        btnPlusClasseId: '#jfontsize-plus',
        btnMinusMaxHits: 10,
        btnPlusMaxHits: 10,
        sizeChange: 1
      };

      if (opcoes) {
        opcoes = $.extend(defaults, opcoes);
      }

      var limite = [];
      var fontsize_padrao = [];

      $(this).each(function (i) {
        limite[i] = 0;
        fontsize_padrao[i];
      });

      $(opcoes.btnMinusClasseId + ', ' + opcoes.btnDefaultClasseId + ', ' + opcoes.btnPlusClasseId).removeAttr('href');
      $(opcoes.btnMinusClasseId + ', ' + opcoes.btnDefaultClasseId + ', ' + opcoes.btnPlusClasseId).css('cursor', 'pointer');

      /* A��o do Bot�o A- */
      $(opcoes.btnMinusClasseId).click(function () {
        $(opcoes.btnPlusClasseId).removeClass('jfontsize-disabled');
        $this.each(function (i) {
          if (limite[i] > (-(opcoes.btnMinusMaxHits))) {
            fontsize_padrao[i] = $(this).css('font-size');
            fontsize_padrao[i] = fontsize_padrao[i].replace('px', '');
            fontsize = $(this).css('font-size');
            fontsize = parseInt(fontsize.replace('px', ''));
            fontsize = fontsize - (opcoes.sizeChange);
            fontsize_padrao[i] = fontsize_padrao[i] - (limite[i] * opcoes.sizeChange);
            limite[i]--;
            $(this).css('font-size', fontsize + 'px');
            if (limite[i] === (-(opcoes.btnMinusMaxHits))) {
              $(opcoes.btnMinusClasseId).addClass('jfontsize-disabled');
            }
          }
        });
      });

      /* A��o do Bot�o A */
      $(opcoes.btnDefaultClasseId).click(function () {
        $(opcoes.btnMinusClasseId).removeClass('jfontsize-disabled');
        $(opcoes.btnPlusClasseId).removeClass('jfontsize-disabled');
        $this.each(function (i) {
          limite[i] = 0;
          $(this).css('font-size', fontsize_padrao[i] + 'px');
        });
      });

      /* A��o do Bot�o A+ */
      $(opcoes.btnPlusClasseId).click(function () {
        $(opcoes.btnMinusClasseId).removeClass('jfontsize-disabled');
        $this.each(function (i) {
          if (limite[i] < opcoes.btnPlusMaxHits) {
            fontsize_padrao[i] = $(this).css('font-size');
            fontsize_padrao[i] = fontsize_padrao[i].replace('px', '');
            fontsize = $(this).css('font-size');
            fontsize = parseInt(fontsize.replace('px', ''));
            fontsize = fontsize + opcoes.sizeChange;
            fontsize_padrao[i] = fontsize_padrao[i] - (limite[i] * opcoes.sizeChange);
            limite[i]++;
            $(this).css('font-size', fontsize + 'px');
            if (limite[i] === opcoes.btnPlusMaxHits) {
              $(opcoes.btnPlusClasseId).addClass('jfontsize-disabled');
            }
          }
        });
      });
    };
  })(jQuery);
  $('.font-size, p, a, p *, .banner-wrap .banner-container h2, .content-with-image-component li, .content-block li, .services-list-wrap li, .wpcf7-form label, .wpcf7-list-item-label, .steps ul li, .steps h3').jfontsize({
    btnMinusClasseId: '#jfontsize-m2', // Defines the class or id of the decrease button
    btnDefaultClasseId: '#jfontsize-d2', // Defines the class or id of default size button
    btnPlusClasseId: '#jfontsize-p2', // Defines the class or id of the increase button
    btnMinusMaxHits: 1, // How many times the size can be decreased
    btnPlusMaxHits: 3, // How many times the size can be increased
    sizeChange: 3 // Defines the range of change in pixels
  });
})(jQuery); // Fully reference jQuery after this point.
